exports = module.exports = require("../../../../web-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3lk5VCd5e1Egu2TRFmxbTm{background-color:#00baff;display:block;position:absolute;top:-2.71429rem;left:48%;-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%);background:#fff;border:.07143rem solid #00baff;padding:.35714rem;white-space:nowrap}._3lk5VCd5e1Egu2TRFmxbTm:after{content:'';display:block;width:.71429rem;height:.71429rem;position:absolute;background:white;border-left:.07143rem solid #00baff;border-bottom:.07143rem solid #00baff;-webkit-transform:rotate(-45deg);-ms-transform:rotate(-45deg);transform:rotate(-45deg);bottom:-.42857rem;left:50%;margin-left:-.35714rem}\n", ""]);

// exports
exports.locals = {
	"toolTip": "_3lk5VCd5e1Egu2TRFmxbTm"
};